/**
 * Shared Braze SDK bootstrap for the customer webapp and the accountant portal.
 *
 * Lili runs two Braze app groups: the customer workspace used by the webapp, and the
 * dedicated Accountants workspace used by the accountant portal. Each app passes its own
 * app-group key and the external id that identifies the user; this module owns only the
 * SDK lifecycle so both stay in sync.
 */

export interface InitBrazeParams {
  /** Braze app-group (workspace) API key. Initialization is skipped when empty. */
  appKey: string;
  baseUrl: string;
  userId: string;
  enableLogging?: boolean;
}

export const initBraze = async ({
  appKey,
  baseUrl,
  userId,
  enableLogging = false,
}: InitBrazeParams) => {
  if (!appKey) {
    return;
  }

  const braze = await import('@braze/web-sdk');
  braze.initialize(appKey, {
    baseUrl,
    enableLogging,
    allowUserSuppliedJavascript: true,
  });
  braze.automaticallyShowInAppMessages();
  braze.changeUser(userId);
  braze.openSession();
};
